import { freeze } from 'icepick';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import { GET_CHAT_APP_STATUS_ERROR, INSTALL_CHAT_APP_ERROR } from '../common/constants';
import type { State } from '../model/types';
import {
	type Action,
	GET_CHAT_APP_STATUS_FAILURE,
	LOAD_CHAT_SETTINGS_PAGE,
	INSTALL_CHAT_APP,
	INSTALL_CHAT_APP_FAILURE,
} from './actions';

export const createInitialState = (baseUrl: BaseUrl, environment: string): State =>
	// @ts-expect-error - TS2322 - Type '{ baseUrl: string; environment: string; isLoading: true; isInstalled: false; isEnabled: false; errorReason: ""; errorMessage: string; }' is not assignable to type 'State'.
	freeze({
		baseUrl,
		environment,
		isLoading: true,
		isInstalled: false,
		isEnabled: false,
		errorReason: '',
		errorMessage: '',
	});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State, action: Action): State => {
	switch (action.type) {
		case GET_CHAT_APP_STATUS_FAILURE:
			return {
				...state,
				isLoading: false,
				errorReason: GET_CHAT_APP_STATUS_ERROR,
				errorMessage: action.payload.errorMessage,
			};

		case LOAD_CHAT_SETTINGS_PAGE:
			return {
				...state,
				isLoading: false,
				isInstalled: action.payload.addonStatus.installed,
				isEnabled: action.payload.addonStatus.enabled,
				errorMessage: '',
			};

		case INSTALL_CHAT_APP:
			return {
				...state,
				isLoading: false,
				errorMessage: '',
			};

		case INSTALL_CHAT_APP_FAILURE:
			return {
				...state,
				isLoading: false,
				errorReason: INSTALL_CHAT_APP_ERROR,
				errorMessage: action.payload.errorMessage,
			};

		default:
			return state;
	}
};
